export default "__VITE_ASSET__GFxDWl2Q__"